<template>
  <router-view />
  <NotificationSystem position="top-right" />
</template>

<script>
import NotificationSystem from '@/components/NotificationSystem.vue'

export default {
  name: 'App',
  components: {
    NotificationSystem
  }
}
</script>
